export const Constants = {
  EmptyString: "",
};
